import { DigitMode, LottoBetList } from '../BetLotto.types'
import { padDigits } from '../../../utils/datetimeFormatUtils'
type GetGridNumber = (
  digitMode: DigitMode,
  selectedRange?: string,
  searchQuery?: string,
) => string[]
export const getGridNumbers: GetGridNumber = (
  digitMode: DigitMode,
  selectedRange = '000',
  searchQuery = '',
) => {
  const start = parseInt(selectedRange, 10)
  const end = start + 99

  if (digitMode === DigitMode.RUNNING) {
    // For running number mode, show numbers 0-9
    const numbers: string[] = []
    for (let i = 0; i <= 9; i++) {
      numbers.push(i.toString())
    }
    if (searchQuery) {
      return numbers.filter((num) => num.includes(searchQuery))
    }
    return numbers
  } else if (digitMode === DigitMode.TWO_DIGIT) {
    // For 2 digits mode, show numbers from 00-99 in the current range
    const numbers: string[] = []
    for (let i = 0; i <= 99; i++) {
      const num = padDigits(i, 2)
      numbers.push(num)
    }
    if (searchQuery) {
      return numbers.filter((num) => num.includes(searchQuery))
    }
    return numbers
  } else {
    // For 3 digits mode
    const numbers: string[] = []
    for (let i = start; i <= end; i++) {
      const num = padDigits(i, 3)
      numbers.push(num)
    }
    if (searchQuery) {
      return numbers.filter((num) => num.includes(searchQuery))
    }
    return numbers
  }
}

export const isNumberActive = (num: string, betList: LottoBetList[]) => {
  return betList.some((bet) => bet.items.some((item) => item.number === num))
}
